export default __webpack_public_path__ + "static/media/mariaFilo_desk_banner_4.90a775cb.jpg";